<template>
  <main class="statistics w100">
    <div class="tabs">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        class="tab"
        :class="{ active: activeTab === tab.key }"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
      </button>
    </div>

    <div class="content">
      <TreatmentsFrequency
        :doctors="Doctors"
        @apply-filters="onApplyTreatmentsFrequency"
        v-if="activeTab === 'frequency'"
        :items="Treatments_Frequency"
        :isLoading="Is_Request_Status"
        :isDownloading="isDownloading"
        @download="onDownloadTreatments"
      />

      <TreatmentsCorrelations
        :doctors="Doctors"
        v-else-if="activeTab === 'correlations'"
        :items="Treatments_Correlations"
        :isLoading="Is_Request_Status"
        :isDownloading="isDownloading"
        @apply-filters="onApplyFilters"
        @download="onDownloadCorrelations"
      />

      <IgienizareOverdue
        @apply-filters="onApplyOverdueFilters"
        @download="onDownloadOverdue"
        :total="Filtered_Patients_Count"
        v-else-if="activeTab === 'overdue'"
        :items="Igienizare_Overdue"
        :thresholdMonths="Threshold_Months"
        :isLoading="Is_Request_Status"
        :isDownloading="isDownloading"
      />

      <DurationValue
        v-else-if="activeTab === 'durationValue'"
        :items="Duration_Value"
        :total="Total_Patients_Duration_Value"
        :statistics="Duration_Value_Statistics"
        :isLoading="Is_Request_Status"
        :isDownloading="isDownloading"
        @apply-filters="onApplyDurationValue"
        @download="onDownloadDurationValue"
      />

      <RecurrenceLoyalty
        v-else-if="activeTab === 'recurrenceLoyalty'"
        :totalPatients="Recurrence_Loyalty_TotalPatients"
        :summary="Recurrence_Loyalty_Summary"
        :cohortAnalysis="Recurrence_Loyalty_Cohorts"
        :patients="Recurrence_Loyalty_Patients"
        :isLoading="Is_Request_Status"
        :isDownloading="isDownloading"
        @download="downloadExcel('recurrence_loyalty')"
      />

      <RelationPatientDoctor
        v-else-if="activeTab === 'relationPatientDoctor'"
        :totalPatients="Relation_Loyalty_TotalPatients"
        :summary="Relation_Patient_Doctor_Summary"
        :doctorsSummary="Relation_Doctors_Summary"
        :patients="Relation_DoctorPatients"
        :isLoading="Is_Request_Status"
        :isDownloading="isDownloading"
        @download="downloadExcel('relation_patient_doctor')"
      />
    </div>
  </main>
</template>

<script>
import TreatmentsFrequency from '../components/Treatments_Frequency.vue'
import TreatmentsCorrelations from '../components/Treatments_Correlations.vue'
import IgienizareOverdue from '../components/Igienizare_Overdue.vue'
import DurationValue from '../components/Duration_Value.vue'
import RecurrenceLoyalty from "@/components/Recurrence_Loyalty.vue";
import RelationPatientDoctor from "@/components/Relation_Patient_Doctor.vue";
import {dispatch} from "@svgdotjs/svg.js";
export default {
  name: 'Statistics',

  components: {
    RecurrenceLoyalty,
    TreatmentsFrequency,
    TreatmentsCorrelations,
    IgienizareOverdue,
    DurationValue,
    RelationPatientDoctor
  },

  data () {
    return {
      tabs: [
        { key: 'frequency', label: 'Frecvență Tratamente' },
        { key: 'correlations', label: 'Corelații Tratamente' },
        { key: 'overdue', label: 'Igienizări Întârziate' },
        { key: 'durationValue', label: 'Durată & Valoare Tratamente' },
        { key: 'recurrenceLoyalty', label: 'Recurență & Loialitate' },
        { key: 'relationPatientDoctor', label: 'Continuitatea Relației Pacient-Medic' }
      ],
      activeTab: 'frequency',
      isDownloading: false,
      loadedTabs: new Set()
    }
  },

  computed: {
    Doctors () {
      return (this.$store.state.medici || []).map(m =>
        m.replace(/^DR\.\s*/, "").trim()
      )
    },
    Treatments_Frequency () {
      return this.$store.state.statistics.Treatments_Frequency
    },
    Treatments_Correlations () {
      return this.$store.state.statistics.Treatments_Correlations
    },
    Igienizare_Overdue () {
      return this.$store.state.statistics.Igienizare_Overdue
    },
    Duration_Value () {
      return this.$store.state.statistics.Duration_Value
    },
    Recurrence_Loyalty_TotalPatients () {
      return this.$store.state.statistics.Recurrence_Loyalty_TotalPatients
    },
    Recurrence_Loyalty_Summary () {
      return this.$store.state.statistics.Recurrence_Loyalty_Summary
    },
    Recurrence_Loyalty_Cohorts () {
      return this.$store.state.statistics.Recurrence_Loyalty_Cohorts
    },
    Duration_Value_Statistics () {
      return this.$store.state.statistics.Duration_Value_Statistics
    },
    Recurrence_Loyalty_Patients () {
      return this.$store.state.statistics.Recurrence_Loyalty_Patients
    },
    Relation_DoctorPatients () {
      return this.$store.state.statistics.Relation_DoctorPatients
    },
    Relation_Doctors_Summary () {
      return this.$store.state.statistics.Relation_Doctors_Summary
    },
    Relation_Loyalty_TotalPatients () {
      return this.$store.state.statistics.Relation_Loyalty_TotalPatients
    },
    Relation_Patient_Doctor_Summary () {
      return this.$store.state.statistics.Relation_Patient_Doctor_Summary
    },
    Threshold_Months () {
      return this.$store.state.statistics.Threshold_Months
    },
    Is_Request_Status () {
      return this.$store.getters.isLoading
    },
    Total_Patients_Duration_Value () {
      return this.$store.state.statistics.Total_Patients_Duration_Value
    },
    Filtered_Patients_Count () {
      return this.$store.state.statistics.Filtered_Patients_Count
    },
  },

  watch: {


    activeTab (newTab) { this.loadTab(newTab) }
  },

  created () {
    this.$store.dispatch('get_medici')
    this.loadTab('frequency')
  },

  methods: {
    loadTab (tab) {
      if (this.loadedTabs.has(tab)) return
      this.loadedTabs.add(tab)

      const actions = {
        frequency: () => this.$store.dispatch('fetchTreatments'),
        correlations: () => this.$store.dispatch('fetchCorrelations', {}),
        overdue: () => this.$store.dispatch('fetchOverdue'),
        durationValue: () => this.$store.dispatch('fetchDurationValue'),
        recurrenceLoyalty: () => this.$store.dispatch('fetchRecurrenceLoyalty'),
        relationPatientDoctor: () => this.$store.dispatch('fetchRelationPatientDoctor'),
      }
      actions[tab]?.()
    },

    onApplyFilters (filters) {
      this.loadedTabs.delete('correlations')
      this.$store.dispatch('fetchCorrelations', filters)
    },

    onApplyOverdueFilters (filters) {
      this.loadedTabs.delete('overdue')
      this.$store.dispatch('fetchOverdue', filters)
    },

    onApplyTreatmentsFrequency (filters) {
      this.loadedTabs.delete('frequency')
      this.$store.dispatch('fetchTreatments', filters)
    },

    onDownloadTreatments (filters) {
      this.downloadExcel('treatments', filters)
    },

    onApplyDurationValue (filters) {
      this.loadedTabs.delete('durationValue')
      this.$store.dispatch('fetchDurationValue', filters)
    },

    onDownloadDurationValue (filters) {
      this.downloadExcel('duration_value', filters)
    },

    onDownloadOverdue (filters) {
      this.downloadExcel('overdue', filters)
    },

    onDownloadCorrelations (filters) {
      this.downloadExcel('correlations', filters)
    },

    async downloadExcel(type, filters = {}) {
      this.isDownloading = true
      try {
        const actions = {
          treatments: () => this.$store.dispatch('downloadTreatmentsExcel', filters),
          correlations: () => this.$store.dispatch('downloadCorrelationsExcel', filters),
          overdue: () => this.$store.dispatch('downloadOverdueExcel', filters),
          duration_value: () => this.$store.dispatch('downloadDurationValueExcel'),
          recurrence_loyalty: () => this.$store.dispatch('downloadRecurrenceLoyaltyExcel'),
          relation_patient_doctor: () => this.$store.dispatch('downloadRelationPatientDoctorExcel'),
        }
        await actions[type]?.()
      } catch {
        alert('Eroare la descărcarea fișierului. Vă rugăm încercați din nou.')
      } finally {
        this.isDownloading = false
      }
    }
  }
}
</script>
<style lang="less">
@import '../assets/styles/var.less';

.statistics {
  @media only screen and (min-width: 0) {
    padding: 40px 40px 30px 8px;
    max-width: 100%;
    overflow-x: hidden;

    .btn-spinner {
      display: inline-block;
      width: 18px;
      height: 18px;
      border: 2px solid rgba(255, 255, 255, 0.35);
      border-top-color: white;
      border-radius: 50%;
      animation: spin 0.7s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }

    .tabs {
      display: flex;
      gap: 0;
      margin-bottom: 44px;
      background: @apple-white;
      padding: 0 16px;
      border-radius: 12px;
      width: fit-content;
      box-shadow: 0 2px 8px @shadow-medium;

    }

    .tab {
      position: relative;
      padding: 14px 10px;
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      color: @apple-text-primary;
      border: none;
      background: transparent;
      transition: color 0.2s ease;
      letter-spacing: -0.01em;
      white-space: nowrap;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 2px;
        background: transparent;
        border-radius: 2px 2px 0 0;
        transition: background 0.2s ease;
      }

      &:hover {
        color: @main-green;
      }

      &.active {
        color: @main-green;
        font-weight: 600;
        background: transparent;
        box-shadow: none;

        &::after {
          background: @main-green;
        }
      }

      .badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-left: 8px;
        padding: 2px 7px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
        background: #e8f0fe;
        color: #1a73e8;
      }
    }

    .action-bar {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 16px;
    }

    .download-btn {
      width: 190px;
      height: 45px;
      padding: 10px 20px;
      border: none;
      cursor: pointer;
      font-weight: 500;
      font-size: 15px;
      border-radius: 8px;
      background: @main-green;
      color: white;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      letter-spacing: -0.01em;
      box-shadow: 0 2px 8px @shadow-dark, 0 1px 2px @shadow-medium;

      &:hover:not(:disabled) {
        background: darken(@main-green, 5%);
        box-shadow: 0 4px 12px @shadow-dark, 0 2px 4px @shadow-medium;
        transform: translateY(-1px);
      }

      &:active:not(:disabled) {
        transform: translateY(0);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    .content {
      padding: 0;
      background: transparent;
      max-width: 100%;
    }

    .correlations-container {
      .container-filters {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .search-filters {
          display: flex;
          align-items: end;
          margin-bottom: 12px;
          gap: 8px;
          .search-btn {
            background-color: @main-green;
            border: none;
            border-radius: 100%;
            height: 34px;
            width: 34px;
            display: flex;
            cursor: pointer;
            align-items: center;
            justify-content: center;
            transition: opacity 0.1s ease-in-out;
            &:hover {
              opacity: 0.8;
            }
          }
          label {
            display: block;
            font-size: 15px;

            input,
            select {
              display: block;
              font-size: 15px;
              border-radius: 2px;
              margin-top: 5px;
              padding: 2px 10px;
            }

            input {
              width: 250px;
            }

            select {
              width: 200px;
              height: 35px;
              border: 1px solid #ddd;
              color: #999;

              &.has-value {
                color: #000;
              }
            }
          }
        }
      }
    }

    .spinner {
      width: 40px;
      height: 40px;
      border: 3px solid @apple-border-light;
      border-top-color: @main-green;
      border-radius: 50%;
      animation: spin 0.8s cubic-bezier(0.4, 0, 0.2, 1) infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .table-wrapper {
      position: relative;
      height: 520px;
      overflow-y: auto;
      overflow-x: auto;
      background: @apple-white;
      border-radius: 12px;
      box-shadow: 0 2px 16px @shadow-medium,
      0 1px 4px @shadow-light;
      max-width: calc(100vw - 280px);
      margin-right: 0;

      &.is-loading {
        .table {
          opacity: 0.3;
          pointer-events: none;
        }
      }

      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: @apple-scrollbar;
        border-radius: 4px;

        &:hover {
          background: @apple-scrollbar-hover;
        }
      }
    }

    .table-loader-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.95);
      z-index: 10;
      border-radius: 12px;

      p {
        color: @apple-text-secondary;
        font-size: 15px;
        font-weight: 500;
        letter-spacing: -0.01em;
        margin-top: 16px;
      }
    }

    .table {
      width: 100%;
      min-width: max-content;
      border-collapse: separate;
      border-spacing: 0;

      th:first-child {
        width: 20px;
      }

      th,
      td {
        padding: 20px 20px;
        text-align: left;
        font-size: 15px;
        background: @apple-white;
        border-bottom: 1px solid @apple-border-light;
        letter-spacing: -0.01em;
        white-space: nowrap;
      }

      th {
        position: sticky;
        top: 0;
        z-index: 2;
        background: @apple-bg-white;
        font-weight: 600;
        font-size: 14px;
        color: @apple-text-secondary;
        text-transform: uppercase;
        letter-spacing: 0.02em;
        border-bottom: 1px solid @apple-border-medium;

        &:first-child {
          border-top-left-radius: 12px;
        }

        &:last-child {
          border-top-right-radius: 12px;
        }
      }

      tbody {
        tr {
          transition: background-color 0.2s ease;

          &:hover {
            background: @apple-bg-white;
          }

          &:last-child {
            td {
              border-bottom: none;

              &:first-child {
                border-bottom-left-radius: 12px;
              }

              &:last-child {
                border-bottom-right-radius: 12px;
              }
            }
          }
        }

        td {
          color: @apple-text-primary;

          &.no-data {
            text-align: center;
            padding: 40px 20px;
            color: @apple-text-secondary;
            font-size: 15px;
            font-weight: 500;
            font-style: italic;
          }
        }
      }
    }

    .urgency-badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.01em;
      transition: all 0.2s ease;

      &.urgency-high {
        background: @urgency-high-bg;
        color: @urgency-high-text;
      }

      &.urgency-medium {
        background: @urgency-medium-bg;
        color: @urgency-medium-text;
      }

      &.urgency-low {
        background: @urgency-low-bg;
        color: @urgency-low-text;
      }
    }

    .summary {
      margin-top: 24px;
      padding: 20px 24px;
      background: @apple-white;
      border-radius: 12px;
      font-size: 14px;
      color: @apple-text-secondary;
      letter-spacing: -0.01em;
      box-shadow: 0 2px 16px @shadow-medium, 0 1px 4px @shadow-light;

      b {
        color: @apple-text-primary;
        font-weight: 600;
      }
    }
  }
}
</style>
